<div class="d-flex justify-content-center text-center">
  <div><h3>Redirencionando...</h3></div>
</div>

<div class="d-flex justify-content-center text-center">
  <div class="br-loading medium"></div>
</div>

<div class="d-flex justify-content-center text-center">
  <div class="w-50">
    <img src="imgs/logo-agsus.png" class="img-fluid" alt="" />
  </div>
</div>
